import { render, staticRenderFns } from "./Medias.vue?vue&type=template&id=3f100172&scoped=true&"
import script from "./Medias.vue?vue&type=script&lang=js&"
export * from "./Medias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f100172",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/lauprvo/Documents/Veloshop2.0/veloshop2/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VFooter } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VImg } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VCardActions,VCardTitle,VContainer,VDivider,VFlex,VFooter,VIcon,VImg,VLayout})
